import { gql } from 'apollo-angular';

export const GET_WISHLIST = gql`
    query ActiveCustomerWishlist {
        activeCustomerWishlist {
            id
            createdAt
            productVariant {
                id
                name
                priceWithTax
                product {
                    id
                    slug
                    name
                    featuredAsset {
                        id
                        preview
                    }
                }
                featuredAsset {
                    id
                    preview
                }
            }
            note
            priority
            availableStock
            isInStock
        }
    }
`;

export const GET_WISHLIST_COUNT = gql`
    query WishlistCount {
        wishlistCount
    }
`;

export const IS_IN_WISHLIST = gql`
    query IsInWishlist($productVariantId: ID!) {
        isInWishlist(productVariantId: $productVariantId)
    }
`;

export const ADD_TO_WISHLIST = gql`
    mutation AddToWishlist($input: AddToWishlistInput!) {
        addToWishlist(input: $input) {
            id
        }
    }
`;

export const REMOVE_FROM_WISHLIST = gql`
    mutation RemoveFromWishlist($productVariantId: ID!) {
        removeFromWishlist(productVariantId: $productVariantId)
    }
`;

export const CLEAR_WISHLIST = gql`
    mutation ClearWishlist {
        clearWishlist
    }
`;
